import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { useTheme } from '@mui/material/styles';
import { InvoiceSummary } from '../../../../app/services/api/generated';

interface InvoicesByStatusProps {
  invoices: InvoiceSummary[];
}

const InvoicesByStatus = ({ invoices }: InvoicesByStatusProps) => {
  const theme = useTheme();

  // Group by status and count
  const data = invoices.reduce<{ [status: number]: number }>((acc, curr) => {
    acc[curr.status] = (acc[curr.status] || 0) + 1;
    return acc;
  }, {});
  const chartData = Object.entries(data).map(([name, value]) => ({ name, value }));

  return (
    <ResponsiveContainer width="100%"
      height={200}>
      <BarChart data={chartData}
        margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
        <CartesianGrid strokeDasharray="3 3"
          stroke={theme.palette.divider} />
        <XAxis dataKey="name"
          stroke={theme.palette.text.primary}
          style={{ fontSize: theme.typography.textSM.fontSize }} />
        <YAxis stroke={theme.palette.text.primary}
          style={{ fontSize: theme.typography.textSM.fontSize }} />
        <Tooltip contentStyle={{
          backgroundColor: theme.palette.background.paper,
          color: theme.palette.text.primary,
          fontFamily: theme.typography.fontFamily,
          fontSize: theme.typography.textSM.fontSize,
        }} />
        <Bar dataKey="value"
          fill={theme.palette.primary.main} />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default InvoicesByStatus;